export const uiPricingRow = {
    name: 'UI Pricing Row',
    description: '',
    displayField: 'title',
    fields: {
        title: {
            name: 'Title',
            type: 'Symbol',
            required: true,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        free: {
            name: 'Free',
            type: 'RichText',
            required: false,
            localized: true,
            disabled: false,
            omitted: false,
            validations: [
                { nodes: {} },
                {
                    enabledNodeTypes: [
                        'embedded-entry-block',
                        'embedded-asset-block',
                        'hyperlink',
                        'entry-hyperlink',
                        'asset-hyperlink',
                        'embedded-entry-inline'
                    ],
                    message: 'Only block entry, asset, link to Url, link to entry, link to asset, and inline entry nodes are allowed'
                }
            ]
        },
        businessClass: {
            name: 'Business Class',
            type: 'RichText',
            required: false,
            localized: true,
            disabled: false,
            omitted: false,
            validations: [
                { nodes: {} },
                {
                    enabledNodeTypes: [
                        'heading-6',
                        'embedded-entry-block',
                        'embedded-asset-block',
                        'hyperlink',
                        'entry-hyperlink',
                        'asset-hyperlink',
                        'embedded-entry-inline'
                    ],
                    message: 'Only heading 6, block entry, asset, link to Url, link to entry, link to asset, and inline entry nodes are allowed'
                }
            ]
        },
        enterprise: {
            name: 'Enterprise',
            type: 'RichText',
            required: false,
            localized: true,
            disabled: false,
            omitted: false,
            validations: [
                { nodes: {} },
                {
                    enabledNodeTypes: [
                        'embedded-entry-block',
                        'embedded-asset-block',
                        'hyperlink',
                        'entry-hyperlink',
                        'asset-hyperlink',
                        'embedded-entry-inline'
                    ],
                    message: 'Only block entry, asset, link to Url, link to entry, link to asset, and inline entry nodes are allowed'
                }
            ]
        }
    }
};
//# sourceMappingURL=uiPricingRow.js.map